import { gql } from '@apollo/client';

export const SALVAR_SIMULADO = gql`
	mutation createSimuladoFB($simulado: inputSimuladoFB) {
		simuladoID: createSimuladoFB(simulado: $simulado)
	}
`;
